import {Edit} from '@material-ui/icons'
import LocationIcon from "assets/Images/icons/LocationIcon.png";
import TrashIcon from "assets/Images/icons/trash.png";
import percentIcon from "assets/Images/icons/percent.png";
import calendarIcon from "assets/Images/icons/CalendarGray.png";
import TimeCircle from "assets/Images/icons/TimeCircle.png";
import { Swiper, SwiperSlide } from "swiper/react";
import reviewUSerImg from "assets/Images/icons/defaultPerson.png";
import reviewUSerFlag from "assets/Images/icons/flag.png";
import StarImg from "assets/Images/icons/Star.png";
import {CustomRatings , CustomRatings1}  from "Utills/CustomRatings"

// ============= this is a booking card component =====================

const BookingCard = ({ data, myListing }) => {
    // captain 
    if (data.mode === true) {
        return (
            <div className={`my-booking-card ${myListing ? 'my_listing_card' : ''}`}>
                <div className="booking-card-left">
                    <div className="booking-img-sq">
                        <img src={data.img} alt="" />
                    </div>
                    <h6 className="booking-card-title">{data.title}</h6>
                    <div className="booking-card-locat">
                        <img src={LocationIcon} alt="" />
                        <p>{data.location}</p>
                    </div>
                    <div className="booking-card-ratings">
                        <CustomRatings name="read-only" value={5} readOnly />&nbsp;
                        <span className="font-weight-bold">5 </span><span className="text-muted">/5</span>&nbsp; <span className="text-muted">(23)</span>
                    </div>
                </div>
                <div className="booking-card-right">
                    <h4 className="book-card-top-tit">{data.mainTitle}</h4>
                    <h6 className="booking-card-subtitle">{data.subtitle}</h6>
                    <div className="booking-card-body">
                        <div className="body-left">
                            <div className="info-line">
                                <div className="title-label">
                                    <p>Location</p>
                                </div>
                                <p className="ans">{data.location}</p>
                            </div>
                            <div className="info-line">
                                <div className="title-label">
                                    <p>Booking Type</p>
                                </div>
                                {myListing ? 
                                <div className="d-flex align-items-center justify-content-start">
                                    <span className="text-sec fw-bold">Intra Day </span>
                                    <span className="text-gr fw-bold"> &nbsp;| &nbsp;</span>
                                    <span className="text-sec fw-bold"> OverNight</span>
                                    </div>
                                :
                                <div className="multi-inputs">
                                    <p className="ans">{data.location}</p>
                                    <div className="time-date-with-icon">
                                        <img src={calendarIcon} alt="" />
                                        <span>8,11,2021</span>
                                    </div>
                                    <div className="time-date-with-icon">
                                        <img src={TimeCircle} alt="" />
                                        <span>10:00 AM</span>
                                    </div>
                                </div>}
                            </div>
                            <div className="info-line">
                                <div className="title-label">
                                    <p>Guests</p>
                                </div>
                                <p className="ans">{data.guests}</p>
                            </div>
                            <div className="info-line">
                                <div className="title-label">
                                    <p>Boat Type</p>
                                </div>
                                <p className="ans">{data.boatType}</p>
                            </div>
                        </div>
                        <div className="booking-card-price">
                            <h4>${data.price}</h4>

                            {myListing ? <span>/Day</span>:
                            <span>({data.days} Day)</span>}
                        </div>
                    </div>
                    {/* footer */}
                    {myListing ? null :
                    <div className="booking-card-footer">
                        <div className="card-review-wrapper">
                            <h5 className="rev-title">
                                My Review
                            </h5>
                            <div className="review-inner">
                                <p>
                                    {data.reviewText}
                                </p>
                                <div className="reviews-incard">
                                    <span className="incard-num">5.0</span>
                                    <CustomRatings1 name="read-only" value={5} readOnly />
                                </div>
                            </div>
                            <div className="card-rev-date">
                                1:20PM & 12.2021
                            </div>
                        </div>
                    </div>}
                    {myListing ? 
                    <div className="booking-card-footer  d-flex justify-content-end align-items-end">
                        <button className="mx-2 rounded-circle my-list-add-edit-view-btn rounded-circle">
                            
                            <img src={percentIcon} alt="" />
                        </button>
                        <button className="mx-2 rounded-circle  my-list-add-edit-view-btn bg-sec rounded-circle">
                            
                            <Edit/>
                        </button>
                        <button className="mx-2 rounded-circle bg-danger del-bt my-list-add-edit-view-btn rounded-circle">
                            <img src={TrashIcon} alt="" />
                        </button>
                    </div>
                    :null}
                </div>
            </div>
        )
    }
    // sailor
    return (
        <div>
            <div className="my-booking-card slider-revs">
                <div className="booking-card-left">
                    <div className="booking-img-sq">
                        <img src={data.img} alt="" />
                    </div>
                    <h6 className="booking-card-title">{data.title}</h6>
                    <div className="booking-card-locat">
                        <img src={LocationIcon} alt="" />
                        <p>{data.location}</p>
                    </div>
                    <div className="booking-card-ratings">
                        <CustomRatings name="read-only" value={5} readOnly />&nbsp;
                        <span className="font-weight-bold">5 </span><span className="text-muted">/5</span>&nbsp; <span className="text-muted">(23)</span>
                    </div>
                </div>
                <div className="booking-card-right">
                    <h4 className="book-card-top-tit">{data.mainTitle}</h4>
                    <h6 className="booking-card-subtitle">{data.subtitle}</h6>
                    <div className="booking-card-body">
                        <div className="body-left">
                            <div className="info-line">
                                <div className="title-label">
                                    <p>Location</p>
                                </div>
                                <p className="ans">{data.location}</p>
                            </div>
                            <div className="info-line">
                                <div className="title-label">
                                    <p>Booking Type</p>
                                </div>
                                <div className="multi-inputs">
                                    <p className="ans">{data.bookingType}</p>
                                </div>
                            </div>
                            <div className="info-line">
                                <div className="title-label">
                                    <p>Guests</p>
                                </div>
                                <p className="ans">{data.guests}</p>
                            </div>
                            <div className="info-line">
                                <div className="title-label">
                                    <p>Boat Type</p>
                                </div>
                                <p className="ans">{data.boatType}</p>
                            </div>
                        </div>
                        <div className="booking-card-price">
                            <h4>${data.price}</h4>
                            <span>/{data.days}</span>
                        </div>
                    </div>
                    {/* footer */}
                    {myListing ? null :
                    <div className="booking-card-footer slider-revs">
                        <div className="card-review-wrapper slider-wrapp">
                            <Swiper
                                spaceBetween={15}
                                slidesPerView={1}
                                speed={500}
                                grabCursor
                                navigation
                                style={{overflow: 'auto !important'}}
                            >
                                {[0, 1, 2,].map((cardItem, i) => {
                                    return (
                                        <SwiperSlide className={`px-2`} key={i}>
                                            <ReviewCard
                                                data={{
                                                    title: "Motorboat Azimut 62",
                                                    location: "Crete . Greece",
                                                    price: "1260",
                                                    flag: reviewUSerFlag,
                                                    profileImg: reviewUSerImg,
                                                    userName:'Alex Jonson',
                                                    reviews: 5,
                                                    reviewTex: 'The trip was awesome! I could bring over my friends and got intraday booking so easily. The captain was so friendly. Thank you',
                                                    date: '1:20PM  8.12.2021'
                                                }}
                                            />
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    )
}


const ReviewCard = ({ data}) => {
    return (
        <div className="review-card-wrapper">
            <div className="review-top-sec">
                <div className="review-user-avatar">
                    <img src={data?.profileImg} alt="" />
                </div>
                <div className="user-rev-info">
                    <div className="w-100">
                    <div className="d-flex flex-wrap">
                    <h6>{data?.userName}</h6>
                    <img className="star-for-user" src={StarImg} alt="" />
                    <h6>{data?.reviews}</h6>
                    </div>
                    <img src={data?.flag || ''} alt="" />
                    </div>
                    <p className="w-100">{data?.reviewTex}</p>
                </div>
            </div>
            <div className="review-card-footer pt-1">
            <p>{data?.date}</p>
            </div>
        </div>
    )
}

export default BookingCard
